import { CompareHelper } from '@barthauer/abc/core';
import { IPersistable, PersistenceService, PersistMode } from '@barthauer/abc/core/data';

export class ChangedObjectPackage {
  object: IPersistable;
  fieldValueHistories: {} = {};
}

export class FieldValueHistory {
  originalValue: any;
  newValue: any;
  get hasChanged(): boolean {
    return this.originalValue !== this.newValue;
  }
}

export class ValueWrapper {
  private _value: any;
  private _objectKey: IPersistable;
  private _fieldName: string;
  private _key: string;

  get fieldName() {
    return this._fieldName;
  }
  get key() {
    return this._key;
  }
  get value(): any {
    return this._value;
  }
  set value(value: any) {
    if (CompareHelper.isNullorEmpty(value)) {
      value = null;
    }
    if (this._value != value) {
      this.persistenceService.addObjectValue(this._objectKey, this.fieldName, value, this._value);
      this._value = value;
    }
  }

  constructor(
    public internalKey: string,
    public valueFieldName: string,
    public initialValue: unknown,
    public objectKey: IPersistable,
    public persistenceService: PersistenceService,
    public initialDisplayText?: string
  ) {
    this._value = initialValue;
    this._objectKey = objectKey;
    this._fieldName = valueFieldName;
    this._key = internalKey;
  }
}

export class ValueWrapperViewModel implements IPersistable {
  private readonly PERSISTENCE_CATEGORY = 'ArenaDataForm';
  id: string;
  objectType: string | number;
  persistenceCategory: string = this.PERSISTENCE_CATEGORY;
  private _listOfValueWrappers: IDictionary<ValueWrapper>;
  public get listOfValueWrappers(): IDictionary<ValueWrapper> {
    return this._listOfValueWrappers;
  }
  public set listOfValueWrappers(value: IDictionary<ValueWrapper>) {
    this._listOfValueWrappers = value;
  }
  abcComponentContainer: any;

  constructor(
    private persistenceService: PersistenceService // private value: any
  ) {}

  changesPersisted(persistMode: PersistMode) {}
  revertChanges() {
    const pack = this.persistenceService.getPendingObjectPackage(this);
    for (const property in pack.fieldValueHistories) {
      if (pack.fieldValueHistories[property]?.hasChanged) {
        let key: string;
        pack.setOriginalFieldHistoryValue(property, (value) => {
          const h = pack.fieldValueHistories[property];
          if (h) {
            h.newValue = value;
          }
          for (const valueWrapperkey in this.listOfValueWrappers) {
            if (this.listOfValueWrappers[valueWrapperkey]?.fieldName === property) {
              key = valueWrapperkey;
            }
          }
        });

        if (this.abcComponentContainer) {
          const c = this.abcComponentContainer[key];
          const w = this.listOfValueWrappers[key];
          if (c && w) {
            w.value = w.initialValue;
          }
        }
      }
    }
  }
}

export interface IDictionary<T> {
  [index: string]: T;
}
